export default {
    init() {
        const form = document.querySelector('[data-news-filter]');

        if (!form) {
            return;
        }

        const dateInput = document.querySelector('#date');
        const dateStart = document.querySelector('#date-start');
        const dateEnd   = document.querySelector('#date-end');

        // Submit the GET form, dropping "all"/empty controls so the resulting
        // URL only carries the filters that are actually set.
        function submitFiltered() {
            form.querySelectorAll('select, input[name]').forEach(el => {
                if (el.value === '' || el.value === '0') {
                    el.disabled = true;
                }
            });
            form.submit();
        }

        form.querySelectorAll('select').forEach(select => {
            select.addEventListener('change', submitFiltered);
        });

        // Date range — daterangepicker writes Ymd into the hidden inputs and
        // then submits the form so the server can filter on the publish date.
        if (dateInput && window.jQuery) {
            const $date = window.jQuery(dateInput);

            const options = {
                autoUpdateInput: false,
                locale: {
                    cancelLabel: 'Clear',
                },
            };

            // Re-open on the current selection when the filter is already set.
            if (dateStart.value && dateEnd.value && window.moment) {
                options.startDate = window.moment(dateStart.value, 'YYYYMMDD');
                options.endDate   = window.moment(dateEnd.value, 'YYYYMMDD');
            }

            $date.daterangepicker(options);

            $date.on('apply.daterangepicker', function (event, picker) {
                dateStart.value = picker.startDate.format('YYYYMMDD');
                dateEnd.value   = picker.endDate.format('YYYYMMDD');
                submitFiltered();
            });

            $date.on('cancel.daterangepicker', function () {
                dateStart.value = '';
                dateEnd.value   = '';
                submitFiltered();
            });
        }
    },
    finalize() {

    },
};
